export default "__VITE_ASSET__DbixzUdq__"